import React from 'react';

/**
 * FormFieldV2 — scoped v2 field primitive (label + control + error).
 * Not tied to shadcn or legacy styles. All classes live under .illumi-v2.
 * Supports input, textarea, and select via `as` prop.
 */
const FormFieldV2 = ({
  id,
  label,
  hint,
  error,
  required = false,
  as = 'input',
  children,
  ...inputProps
}) => {
  const errorId = error ? `${id}-error` : undefined;
  const hintId = hint ? `${id}-hint` : undefined;
  const describedBy = [errorId, hintId].filter(Boolean).join(' ') || undefined;
  const isSelect = as === 'select';
  const isTextarea = as === 'textarea';

  return (
    <div className={`iv2-field ${error ? 'iv2-field-invalid' : ''}`} data-testid={`iv2-field-${id}`}>
      <label htmlFor={id} className="iv2-field-label">
        {label}
        {required && <span className="iv2-field-req" aria-hidden="true"> *</span>}
      </label>
      {hint && <span id={hintId} className="iv2-field-hint">{hint}</span>}

      {isSelect ? (
        <select
          id={id}
          className="iv2-field-control"
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={describedBy}
          aria-required={required || undefined}
          data-testid={`iv2-input-${id}`}
          {...inputProps}
        >
          {children}
        </select>
      ) : isTextarea ? (
        <textarea
          id={id}
          className="iv2-field-control iv2-field-textarea"
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={describedBy}
          aria-required={required || undefined}
          data-testid={`iv2-input-${id}`}
          {...inputProps}
        />
      ) : (
        <input
          id={id}
          className="iv2-field-control"
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={describedBy}
          aria-required={required || undefined}
          data-testid={`iv2-input-${id}`}
          {...inputProps}
        />
      )}

      {error && (
        <span id={errorId} className="iv2-field-error" role="alert" data-testid={`iv2-error-${id}`}>
          {error}
        </span>
      )}
    </div>
  );
};

export default FormFieldV2;
